import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiErrorMessage, requestPasswordReset } from '@/api/client';
import { AuthShell } from '@/components/auth/AuthShell';
import { usePageMeta } from '@/hooks/use-page-meta';

export function ForgotPassword() {
  usePageMeta("Reset your password — Aura", { noindex: true })
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Forgot your password?"
      subtitle="Enter your email and we'll send you a reset link."
      footer={
        <span>
          Remembered it?{' '}
          <Link to="/login" className="">
            Back to sign in
          </Link>
        </span>
      }
    >
      {sent ? (
        <p className="auth-status tone-success aura-panel-in">
          If an account with that email exists, a reset link is on its way. Check your inbox — the link
          expires in one hour.
        </p>
      ) : (
        <>
          {error && (
            <div className="auth-banner auth-banner-error" role="alert">{error}</div>
          )}
          <form onSubmit={onSubmit} className="auth-form">
            <label className="auth-field">
              <span>Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                autoComplete="email"
              />
            </label>
            <button type="submit" className="btn btn-primary" disabled={busy}>
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        </>
      )}
    </AuthShell>
  );
}
